module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    style: ({
      display: _vm.ativo ? 'block' : 'none'
    })
  }, [_c('div', {
    staticClass: "loading-container"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "loading-message"
  }, [_vm._v(_vm._s(_vm.mensagem || 'Só um momento que estamos carregando as informações...'))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-fading-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-circle"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ff53514", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff53514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Loading.vue
// module id = 1121
// module chunks = 1